// react-markdown / remark-gfm configuration used by Sidekick's CLW agent
// sidebar. Agent messages arrive as markdown (`**bold**`, headers, code,
// lists, tables); rendering them natively keeps the chat readable.
// Module-scoped arrays so react-markdown doesn't re-render when the
// plugin / component identities change between turns.

import remarkGfm from 'remark-gfm';

export const AI_MD_PLUGINS = [remarkGfm];

export const AI_MD_COMPONENTS = {
  p: ({ node, ...props }) => <p className="clw-ai-md-p" {...props} />,
  a: ({ node, ...props }) => <a target="_blank" rel="noopener noreferrer" {...props} />,
  // react-markdown v10 distinguishes block code via the `language-*`
  // className that fenced blocks carry — inline backticks don't get one.
  code: ({ className, children, ...props }) => {
    const isBlock = /\blanguage-/.test(className || '');
    return isBlock
      ? <code className={`clw-ai-md-code-block ${className}`} {...props}>{children}</code>
      : <code className="clw-ai-md-code-inline" {...props}>{children}</code>;
  },
  // Tables get their own scroll container. The agent emits GFM tables whose
  // content is not narrow — a row name plus two date transitions — and inside a
  // ~520px sidebar the last column was simply cut off with no way to reach it.
  // Scrolling the WRAPPER rather than the table keeps the table a real table
  // (`display: block` on a <table> to make it scrollable collapses its column
  // sizing), so headers stay aligned with their cells.
  table: ({ node, ...props }) => (
    <div className="clw-ai-md-tablewrap">
      <table {...props} />
    </div>
  ),
};
